import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { ButtonShelf, SecondaryButton, SubmitButton, useHasUnansweredQuestions } from './CurrentQuestionParts';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { textBlock } from '@/uiPrimitives/typography/text';
import { hiddenAboveMQ640px, hiddenAccessibleBelowMQ640px, hiddenBelowMQ640px, visiblyHidden } from '@/uiPrimitives/utility/display.css';
import { AnyRenderedQuestion, GivenAnswers } from '../question.types';
export const QuestionButtons = t0 => {
  const $ = _c(23);
  const {
    allQuestions,
    givenAnswers,
    onPrevious
  } = t0;
  let t1;
  if ($[0] !== allQuestions || $[1] !== givenAnswers) {
    t1 = {
      allQuestions,
      givenAnswers
    };
    $[0] = allQuestions;
    $[1] = givenAnswers;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const hasUnansweredQuestions = useHasUnansweredQuestions(t1);
  let t2;
  if ($[3] !== onPrevious) {
    t2 = onPrevious != null && <SecondaryButton onClick={onPrevious}>{translateInline({
        en: "Previous",
        nl: "Vorige"
      })}{" "}<span className={classes(hiddenAccessibleBelowMQ640px)}>{translateInline({
          en: "question",
          nl: "vraag"
        })}</span></SecondaryButton>;
    $[3] = onPrevious;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== hasUnansweredQuestions) {
    t3 = classes(textBlock({
      color: "inherit",
      colorTransition: "0ms"
    }), !hasUnansweredQuestions && visiblyHidden);
    $[5] = hasUnansweredQuestions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = translateInline({
      en: "Next",
      nl: "Volgende"
    });
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={classes(hiddenAccessibleBelowMQ640px)}>{translateInline({
        en: "question",
        nl: "vraag"
      })}</span>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3) {
    t6 = <span className={t3}>{t4}{" "}{t5}</span>;
    $[9] = t3;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== hasUnansweredQuestions) {
    t7 = classes(textBlock({
      color: "inherit",
      colorTransition: "0ms"
    }), hasUnansweredQuestions && visiblyHidden);
    $[11] = hasUnansweredQuestions;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className={classes(hiddenAboveMQ640px)}><span className={classes(hiddenAccessibleBelowMQ640px)}>{translateInline({
          en: "Show ",
          nl: "Toon "
        })}</span>{translateInline({
        en: "Result",
        nl: "Resultaat"
      })}</span>;
    t9 = <span className={classes(hiddenBelowMQ640px)}>{translateInline({
        en: "Show result",
        nl: "Toon resultaat"
      })}</span>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7) {
    t10 = <span className={t7}>{t8}{t9}</span>;
    $[15] = t7;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6) {
    t11 = <SubmitButton>{t6}{t10}</SubmitButton>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t2) {
    t12 = <ButtonShelf>{t2}{t11}</ButtonShelf>;
    $[20] = t11;
    $[21] = t2;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};